import React from 'react'
import './styles.scss'
interface Props  {
  text?: () => string | JSX.Element
}

export const Summary = ({ text }: Props) => {
  return (
    <div className='Summary'>
      {text && <div className='text'>{text()}</div>}
    </div>
  )
}
